// extracted by mini-css-extract-plugin
module.exports = {"chips-container":"Chip_chips-container__3FrWx","chip":"Chip_chip__U1xrY","button-remove":"Chip_button-remove___JD4t"};